<template>
    <div class="col-sm-9">
        <div class="new_soproni_small_area">
            <div class="row">
                <div class="col-sm-12">
                    <div class="section_title_box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="section_title">
                                    <div class="section_title_cont text-left">
                                        <h3>SZEMÉLYES ADATOK</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-sm-12">
                    <div class="ked_menu_box">
                        <div class="ked_menu_box_cont">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="szem_title">
                                        <p>SZÁMLÁZÁSI ADATOK</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <data-view :data="wrapper.invoicingData"></data-view>


            <section >
                <div class="row">
                    <div class="col-sm-12">
                        <div class="ked_menu_box">
                            <div class="ked_menu_box_cont">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="szem_title">
                                            <p>SZÁLLÍTÁSI ADATOK</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-9">
                                    <div class="vezteknev_title">
                                        <h6>Szállítási adatok megegyeznek a számlázási adatokkal</h6>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <input class="cb-shipping" type="checkbox" placeholder="" v-model="wrapper.sameInvoicingShipping">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <data-view v-if="!wrapper.sameInvoicingShipping" :data="wrapper.shippingData"></data-view>
            </section>

            <div class="row">
                <div class="kedvenciam_all_area for_nw_form">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all" style="padding-left:0;padding-right:0;">

                            <div class="row">

                                <div class="col-sm-12">
                                    <div class="thm_last_btn text-center no-margin">
                                        <a @click="save">VÁLTOZTATÁSOK MENTÉSE</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Data from '@pages/dashboard/profile/Data.vue'
import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    components:{
        DataView:Data
    },
    data:function () {
        return {
            wrapper:{
                invoicingData:{},
                shippingData:{},
                sameInvoicingShipping:false,
            },
        };
    },
    created:function () {
        var self = this;
        this.connDataGet(function (r) {
            self.wrapper = r.data
        })
    },
    methods:{
        save:function () {
            var self = this;
            this.connDataUpdate(this.wrapper,function (r) {
                toastr.success('Adatok elmentve')
            })
        }
    }

}
</script>

<style>
input[type=checkbox] {
  transform: scale(1.5);
}
@media(max-width:767px){
  .no-margin{
      margin: 0px;
      padding: 0px;

  }
}
</style>



// WEBPACK FOOTER //
// Profile.vue?0c88fb5e